import React, { useContext, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Typography } from "@mui/material";
import { ClientsContext } from "../context/ClientsContextProvider";
import { PostClient } from "../types";
import PlanSelectTable from "./PlanSelectTable";

const schema = yup.object().shape({
  selectedPlanId: yup.string(),
});

export type ClientPlanData = yup.InferType<typeof schema>;

const ClientPlanForm = React.forwardRef(
  (
    props: {
      selectedStep: number;
      setSelectedStep: React.Dispatch<React.SetStateAction<number>>;
    },
    ref
  ) => {
    const { client, setClient } = useContext(ClientsContext);
    const { handleSubmit, setValue, watch } = useForm({
      resolver: yupResolver(schema),
    });
    const selectedPlanId = watch("selectedPlanId");
    function updateData() {
      const data = client?.planId;
      if (!data) return;
      setValue("selectedPlanId", data);
    }
    useEffect(() => {
      updateData();
    }, [client]);

    const onSubmit = async (data: ClientPlanData) => {
      const planId = data.selectedPlanId;
      const newClientData: PostClient = {
        ...client,
        planId: planId,
      };
      setClient(newClientData);
      props.setSelectedStep(props.selectedStep + 1);
    };

    React.useImperativeHandle(ref, () => ({
      async submitForm() {
        await handleSubmit(onSubmit)();
      },
    }));
    return (
      <form
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <div
          style={{
            width: "95%",
            paddingBottom: "20px",
          }}
        >
          <>
            <div
              style={{
                width: "100%",
                marginBottom: "10px",
                display: "flex",
              }}
            >
              <PlanSelectTable
                selectedPlan={selectedPlanId || ""}
                setValue={setValue}
              />
            </div>
            <Typography>
              Os recursos destacados podem ser contratados sob demanda,
              independente do plano contratado
            </Typography>
          </>
        </div>
      </form>
    );
  }
);

export default ClientPlanForm;
